import { withStyles } from '@material-ui/core';

import DateRangeSelect from './component';
import styles from './styles';

export default withStyles(styles)(DateRangeSelect);
